import React from "react";
import { DropdownV2, InputV2 } from "../../../FormControlsV2";
import { ProductIncomingTaskFiltersProps } from "./types";

export function ProductIncomingTaskFilters({
  farmOptions,
  currentFarm,
  onFarmChange,
  farmLabel,
  allResponsibles,
  currentResponsible,
  onResponsibleChange,
}: ProductIncomingTaskFiltersProps) {
  return (
    <div className="filters-container filters-wrap">
      <div className="filters-dropdown">
        <DropdownV2
          name="create-task-farm"
          label="Fazenda"
          placeholder="Selecionar fazenda"
          options={farmOptions}
          value={currentFarm ?? null}
          menuMount="overlay"
          onChange={(opt) => onFarmChange(opt?.value)}
        />
      </div>
      <div className="filters-dropdown">
        <InputV2
          name="create-task-deposit"
          label="Depósito"
          value="Depósito central"
          disabled
        />
      </div>
      <div className="filters-dropdown filters-dropdown__full-width">
        <DropdownV2
          name="create-task-responsible"
          label="Responsável"
          placeholder="Selecionar responsável pelo recebimento..."
          options={allResponsibles}
          value={currentResponsible ?? null}
          menuMount="overlay"
          onChange={(opt) => onResponsibleChange(opt)}
        />
      </div>
    </div>
  );
}
